import React, { FC } from "react";
import AgentForm from '../molecules/AgentForm'
import { useLocation,useParams } from "react-router-dom";
import MainLayout from "../../Layouts/MainLayout";
//Agent-form
const AgentFormPage:FC =()=>{
  const location = useLocation();
  const {crewName }= location.state || 'crew'
  const {agentId} = useParams()
 
  return (
   <MainLayout>
     < AgentForm crewName = {crewName} agentId ={agentId || ''}/>
   </MainLayout>
  )
}
export default AgentFormPage;